import apiCall from "../../axios";

export interface AltaTalkdownSupportCamera {
  cameraId: string;
  vendorCameraId?: string;
  aipxGrainId?: string;
}

export interface AltaTalkdownSupportRequest {
  cameras: AltaTalkdownSupportCamera[];
}

export interface AltaTalkdownSupportResponse {
  cameraSupport?: Record<string, boolean>;
  success?: boolean;
  message?: string;
}

const getTalkdownCameraSpeakerSupport = async (
  body: AltaTalkdownSupportRequest
): Promise<AltaTalkdownSupportResponse> => {
  try {
    const response = await apiCall(
      "POST",
      "/avigilonalta/talkdown/camera-speaker-support",
      body
    );

    return (response.data?.data ?? response.data) as AltaTalkdownSupportResponse;
  } catch (error: any) {
    console.error("getTalkdownCameraSpeakerSupport Error:", error?.message);
    return {
      success: false,
      message: error?.message || "Failed to resolve Alta talkdown camera support.",
      cameraSupport: {},
    };
  }
};

export default getTalkdownCameraSpeakerSupport;
